class FrontendEmbedded {
  constructor () {
    this._shareOpened = this._shareOpened.bind(this)
    this._messageReceived = this._messageReceived.bind(this)
    this._updatePageHeight = this._updatePageHeight.bind(this)
    this._begin = this._begin.bind(this)
    this.lastContentHeight = 0
    this.shareDialogTopOffset = 0

    this._cookieCheck()
    this._bindEvents()
  }

  _bindEvents () {
    $(document).on('opened.fndtn.reveal', '[data-reveal]', this._shareOpened)
    $(window).on('message', this._messageReceived)
    $(document).ready(this._begin)
  }

  _shareOpened (e) {
    if (!(this.shareDialogTopOffset > 0)) { return }

    $(e.currentTarget).css({ top: 160 + this.shareDialogTopOffset })
  }

  _messageReceived (e) {
    if (typeof e.data !== 'string') { return }

    if (e.data.indexOf('buyapowa:scroll:') !== -1) {
      this.shareDialogTopOffset = parseInt(e.data.substring(16))
    }
  }

  _updatePageHeight () {
    const contentHeight = Math.round($('#page_end').offset().top)

    if (this.lastContentHeight !== contentHeight) {
      window.parent.postMessage(`buyapowa:height:${contentHeight}`, '*')
      this.lastContentHeight = contentHeight
    }

    setTimeout(this._updatePageHeight, 300)
  }

  _begin () {
    window.parent.postMessage('buyapowa:loaded', '*')
    this._updatePageHeight()
  }

  _cookieCheck () {
    const cookieTestUrl = $("meta[name='cookie_test_url']").attr('content')
    const cookieErrorUrl = $("meta[name='cookie_error_url']").attr('content')

    if (cookieTestUrl == null) { return }
    if (cookieErrorUrl == null) { return }

    return $.ajax({
      url: cookieTestUrl,
      xhrFields: {
        withCredentials: true
      },
      error (jqXHR) {
        if (jqXHR.status === 400) {
          window.parent.postMessage(`buyapowa:cookie_error:${encodeURIComponent(cookieErrorUrl)}`, '*')
        }
      }
    })
  }
}

new FrontendEmbedded() // eslint-disable-line no-new
